<template>
    <span>{{ displayValue }}</span>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        capitalize: {
            default: false,
            type: Boolean,
        },
        add_dot: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        ...mapState(['currency']),
        ...mapGetters(['product']),
        displayValue() {
            if (this.currency) {
                switch (this.product.price.full.currency_symbol) {
                    case '$':
                        return this.prepare(this.$t('currency.dollars'));
                    case '£':
                        return this.prepare(this.$t('currency.pounds'));
                    case '€':
                        return this.prepare(this.$t('currency.euros'));
                }
            } else {
                return null;
            }
        },
    },
    methods: {
        prepare(value) {
            if (this.capitalize) {
                if (this.add_dot) {
                    return value.charAt(0).toUpperCase() + value.slice(1) + '.';
                }
                return value.charAt(0).toUpperCase() + value.slice(1);
            }

            if (this.add_dot) {
                return value + '.';
            }

            return value;
        },
    },
};
</script>
